<div class="fixed top-4 right-4 z-50 flex flex-col gap-2">
  @for (message of messages(); track message.id) {
    <div
      class="flex min-w-80 max-w-md items-center justify-between gap-4 rounded-lg px-4 py-3 shadow-lg transition-all duration-300 ease-in-out"
      [class]="getSnackbarClasses(message.type)"
      role="alert"
      [attr.aria-live]="message.type === SnackbarType.ERROR ? 'assertive' : 'polite'"
    >
      <div class="flex items-center gap-3">
        <div class="flex-shrink-0">
          @switch (message.type) {
            @case (SnackbarType.SUCCESS) {
              <img src="/icons/success.svg" alt="Success" class="h-5 w-5" />
            }
            @case (SnackbarType.ERROR) {
              <img src="/icons/error.svg" alt="Error" class="h-5 w-5" />
            }
            @case (SnackbarType.WARNING) {
              <img src="/icons/warning.svg" alt="Warning" class="h-5 w-5" />
            }
            @case (SnackbarType.INFO) {
              <img src="/icons/info.svg" alt="Info" class="h-5 w-5" />
            }
          }
        </div>
        <p class="text-sm font-medium">{{ message.message }}</p>
      </div>
      <button
        type="button"
        (click)="closeSnackbar(message.id)"
        class="flex-shrink-0 rounded-md p-1.5 transition-opacity hover:opacity-70 focus:outline-none focus:ring-2 focus:ring-offset-2"
        [attr.aria-label]="'Close notification'"
      >
        <img src="/icons/close.icon.svg" alt="Close" class="h-4 w-4" />
      </button>
    </div>
  }
</div>
